/**
 * Template HTML content for the "reason for pursuing this need" rich text field.
 * Used as placeholder and initial value in need creation/editing forms.
 */
export const NEED_REASON_TEMPLATE = `
<p>
  <b>How is this need currently impacting the member's access to care?</b>
</p>
<p>&nbsp;</p>

<p>
  <b>What has the member already tried?</b>
</p>
<p>&nbsp;</p>

<p>
  <b>What is the level of urgency?</b>
</p>
<p>&nbsp;</p>

<p>
  <b>How will you know when this need is fulfilled?</b>
</p>
<p>&nbsp;</p>

<p>
  <b>What are the steps you expect to take to help this member meet their goal?</b>
</p>
<p>&nbsp;</p>
`;
